import dayjs from 'dayjs'
import dayOfYear from 'dayjs/plugin/dayOfYear'

import { api } from '@api'
import { Filters, GetTicketsResponse, Ticket } from '@types'

dayjs.extend(dayOfYear)

type Params = {
  filters?: Filters
}

const getTickets = async (params: Params) => {
  const { filters } = params
  const response = await api.get<GetTicketsResponse>('/tickets', {
    params: filters,
  })

  const ticketsAux = response.data.tickets?.tickets.map((ticket: Ticket) => {
    const withdrawalDay = dayjs(ticket.withdrawalDate).format('DD-MM-YYYY')
    const withdrawalTime = dayjs(ticket.withdrawalDate).format('HH:mm')
    const withdrawalDayOfYear = dayjs(ticket.withdrawalDate).dayOfYear() // revisar compatibilidad con api al cambiar de año
    return {
      ...ticket,
      withdrawalDay,
      withdrawalTime,
      withdrawalDayOfYear,
    }
  }) as Ticket[]
  const tickets = ticketsAux
    ? {
        tickets: ticketsAux,
        total: response.data.tickets?.total,
      }
    : response.data.tickets
  return tickets
}

export const TicketsApi = {
  getTickets,
}
